import { render, staticRenderFns } from "./YlHotelSyncRule.vue?vue&type=template&id=347d3f20&scoped=true"
import script from "./YlHotelSyncRule.vue?vue&type=script&lang=js"
export * from "./YlHotelSyncRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347d3f20",
  null
  
)

export default component.exports